// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".settings-link[data-v-03bb1a09] {\n  font-weight: 500;\n  width: 100%;\n  font-size: 14px;\n  line-height: 14px;\n  padding: 8px 0px;\n  color: var(--v-primary-base);\n}\n.settings-link[data-v-03bb1a09]:hover {\n  color: var(--v-primary-base);\n}", ""]);
// Exports
module.exports = exports;
